export const oilCapacityType = ['mililiters', 'grams'];

export const states = [
    { name: 'BROKEN', value: 'BROKEN' },
    { name: 'DEFECTIVE', value: 'DEFECTIVE' },
    { name: 'AVAILABLE', value: 'AVAILABLE' },
    { name: 'USED', value: 'USED' },
];